import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ListGroup from 'react-bootstrap/ListGroup';
import Badge from 'react-bootstrap/Badge';
import Link from 'next/link';
import Image from 'next/image';
import buyingProfileIcon from '@/public/images/icons/dashboard/buyer-profile.svg';
import sellerProfileIcon from '@/public/images/icons/dashboard/seller-profile.svg';
import accountIcon from '@/public/images/icons/dashboard/account.svg';
import servicesIcon from '@/public/images/icons/dashboard/services.svg';
import feedbackIcon from '@/public/images/icons/dashboard/feedback.svg';
import arrowLeftIcon from '@/public/images/icons/dashboard/left.svg';
import translationFallback from '@/utilites/translations/translationFallback';
import { useTranslation } from 'next-i18next';
import styles from '../../menu.module.scss';
import { useRouter } from 'next/router';
import { UserDTO } from '@/types/other';
import useStaticNotifications from '@/hooks/useStaticNotifications';

const SettingsSubMenu = ({ user }: { user: UserDTO | null }) => {
  const { sellerProfileNoti, buyerProfileNoti } = useStaticNotifications();
  const { pathname } = useRouter();
  const isActive = (query: string) => {
    return query === pathname;
  };
  const { t } = useTranslation('index');
  const { t: tCommon } = useTranslation('common');
  const { t: tDashboard } = useTranslation('dashboard');

  return (
    <Row>
      <Col className="ps-4">
        <Link
          href="/dashboard"
          className="d-block mb-5 text-muted font-size-16 fw-500 text-decoration-none"
        >
          <Image
            src={arrowLeftIcon}
            width={20}
            height={20}
            alt="Buy"
            className="me-2"
          />{' '}
          {translationFallback(
            'settings.back_to_dashboard',
            tDashboard('settings.back_to_dashboard'),
            'Back to Dashboard'
          )}
        </Link>
        <h5 className="font-size-12 fw-500 ps-3">
          {' '}
          {translationFallback(
            'settings.settings',
            tDashboard('settings.settings'),
            'Settings'
          )}
        </h5>
        <ListGroup variant="flush" className={`${styles.dashboardMenu} me-2`}>
          <ListGroup.Item
            className={isActive('/dashboard/settings') ? styles.active : ''}
          >
            <Link
              href="/dashboard/settings"
              className="d-flex justify-content-start align-items-center w-100"
            >
              <Image
                src={accountIcon}
                width={24}
                height={24}
                alt="Buy"
                className="me-2"
              />
              {translationFallback(
                'settings.your_account',
                tDashboard('settings.your_account'),
                'Your Account'
              )}{' '}
              {buyerProfileNoti && (
                <Badge
                  bg="danger"
                  className="rounded-pill font-size-12 fw-semibold ms-auto"
                >
                  1
                </Badge>
              )}
            </Link>
          </ListGroup.Item>
          <ListGroup.Item
            className={
              isActive('/dashboard/settings/buyer-profile') ? styles.active : ''
            }
          >
            <Link
              href="/dashboard/settings/buyer-profile"
              className="d-flex justify-content-start align-items-center w-100"
            >
              <Image
                src={buyingProfileIcon}
                width={24}
                height={24}
                alt="Buy"
                className="me-2"
              />
              {translationFallback(
                'settings.buyer_profile',
                tDashboard('settings.buyer_profile'),
                'Buyer Profile'
              )}{' '}
              {buyerProfileNoti && (
                <Badge
                  bg="danger"
                  className="rounded-pill font-size-12 fw-semibold ms-auto"
                >
                  1
                </Badge>
              )}
            </Link>
          </ListGroup.Item>
          <ListGroup.Item
            className={`
              ${
                isActive('/dashboard/settings/seller-profile')
                  ? styles.active
                  : ''
              }
                `}
          >
            <Link
              href="/dashboard/settings/seller-profile"
              className="d-flex justify-content-start align-items-center w-100"
            >
              <Image
                src={sellerProfileIcon}
                width={24}
                height={24}
                alt="Buy"
                className="me-2"
              />
              {translationFallback(
                'settings.seller_profile',
                tDashboard('settings.seller_profile'),
                'Seller Profile'
              )}
              {sellerProfileNoti && (
                <Badge
                  bg="danger"
                  className="rounded-pill font-size-12 fw-semibold ms-auto"
                >
                  {sellerProfileNoti}
                </Badge>
              )}
            </Link>
          </ListGroup.Item>

          <ListGroup.Item
            className={
              isActive('/dashboard/settings/services') ? styles.active : ''
            }
          >
            <Link
              href="/dashboard/settings/services"
              className="d-flex justify-content-start align-items-center"
            >
              <Image
                src={servicesIcon}
                width={24}
                height={24}
                alt="Buy"
                className="me-2"
              />
              {translationFallback(
                'settings.services',
                tDashboard('settings.services'),
                'Services'
              )}
            </Link>
          </ListGroup.Item>
          <ListGroup.Item
            className={
              isActive('/dashboard/settings/feedback') ? styles.active : ''
            }
          >
            <Link
              href="/dashboard/settings/feedback"
              className="d-flex justify-content-start align-items-center"
            >
              <Image
                src={feedbackIcon}
                width={24}
                height={24}
                alt="Buy"
                className="me-2"
              />
              {translationFallback(
                'settings.feedback',
                tDashboard('settings.feedback'),
                'Feedback'
              )}
            </Link>
          </ListGroup.Item>
        </ListGroup>
      </Col>
    </Row>
  );
};

export default SettingsSubMenu;
